import request from '../../libs/request';

export default {
  home: (queryParams, siteId, token) => {
    return request(`api/v2/${siteId}/recsForPlacements`).get({ queryParams, token });
  },

  product: (productId, queryParams, siteId, token) => {
    return request(`${siteId}/produto/${productId}/recomendados`, 'ocean').get({
      queryParams,
      token,
    });
  },
};
